import { ca } from '@cmao/analytics';
import { getQueryString } from './common';
import { config } from './config';

const ProductCode = 'landpage';
type ReportRecord = Record<string, string | number | boolean>

/**
 * @description 获取渠道信息
 * @author Wynne
 * @date 2021-03-17
 */
export function getSource() {
  // 默认渠道
  const DEFAULT_SOURCE = 'octopus-marketing';
  let {
    utm_source: utmSource = '',
    utm_term: utmTerm = '',
    utm_content: utmContent = '',
  } = getQueryString();
  // 优先取 URL 上 utm_source，否则取 from 链接里的 utm_source
  if (!utmSource) {
    const { from } = getQueryString();
    const fromUrl = decodeURIComponent(from);
    const queryObj = getQueryString(fromUrl);
    utmSource = queryObj.utm_source;
    utmTerm = queryObj.utm_term;
    utmContent = queryObj.utm_content;
  }
  return {
    utmSource: utmSource || DEFAULT_SOURCE,
    utmTerm: utmTerm || DEFAULT_SOURCE,
    utmContent: utmContent || '',
  };
}

/**
 * @description 初始化ca埋点上传
 * @author Wynne
 * @date 2021-03-17
 */
export const caInit = () => {
  const env = config.env !== 'production' ? '_dev' : '';
  ca.init({
    product_code: ProductCode,
    url: `https://collection.codemao.cn/report/${ProductCode}${env}`,
    debug: false,
  });
};

/**
 * @description 埋点上报事件
 * @author Wynne
 * @date 2021-03-17
 */
const caEvent = (key:string, segmentation:ReportRecord) => {
  ca.add_event({
    key,
    segmentation,
  });
};

const { utmSource, utmTerm, utmContent } = getSource();

/**
 * @description 点击上报事件
 * @author Wynne
 * @date 2021-03-17
 */
export function caClick(buried:string, pageId:string, userId:string, isLogin:boolean, param:ReportRecord):void {
  caEvent('landpage_marketing_click', {
    utm_source: utmSource || '',
    utm_term: utmTerm || '',
    utm_content: utmContent || '',
    button_id: `${pageId}_${buried}`,
    from: document.referrer,
    page_id: pageId,
    user_id: userId, // 用户id，未登录为0
    is_login: isLogin ? 1 : 0, // 是否登录
    ...param,
  });
}

/**
 * @description 监听进入事件上报
 * @author Wynne
 * @date 2021-03-17
 */
export const caPageStart = (pageId = '', userId = '', isLogin = false, param:ReportRecord = {}) => {
  const reportObj = {
    utm_source: utmSource,
    utm_term: utmTerm,
    utm_content: utmContent,
    user_id: userId, // 用户id，未登录为0
    is_login: isLogin ? 1 : 0, // 是否登录
    page_id: pageId,
    from: document.referrer, // 来源落地页地址
    ...param,
  };
  caEvent('landpage_marketing_start', reportObj);
};

/**
 * @description 监听点击事件上报
 * @author Wynne
 * @date 2021-03-17
 */
export const initClickReport = (pageId = '', userId = '', isLogin = false, param:ReportRecord = {}) => {
  const getParent = function(ele:HTMLElement):Element | null {
    if (ele.getAttribute('data-buried')) {
      return ele;
    } else if (ele.parentElement) {
      return getParent(ele.parentElement);
    } else {
      return null;
    }
  };

  // 点击上报
  document.addEventListener('click', (event:any) => {
    const partEle = getParent(event.target);
    if (partEle) {
      caClick(partEle.getAttribute('data-buried') || '', pageId, userId, isLogin, param);
    }
  });
};
